// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchFault {
constructor({
        id = null,
        emArchFaultTypeId = '',
        emArchBasicDataCode = '',
        code = '',
        name = '',
        faultDetail = '',
        faultEffect = '',
        faultSymptom = '',
        faultCause = '',
        faultCauseExplanation = '',
        attachment = '',
        emArchToolKitId = '',
        isGeneral = '',
        attachmentList = ''}
= {}) {
    this.id = id;
    this.emArchFaultTypeId = emArchFaultTypeId;
    this.emArchBasicDataCode = emArchBasicDataCode;
    this.code = code;
    this.name = name;
    this.faultDetail = faultDetail;
    this.faultEffect = faultEffect;
    this.faultSymptom = faultSymptom;
    this.faultCause = faultCause;
    this.faultCauseExplanation = faultCauseExplanation;
    this.attachment = attachment;
    this.emArchToolKitId = emArchToolKitId;
    this.isGeneral = isGeneral;
    this.attachmentList = attachmentList;
}
}

function newEntity() {
return new EmArchFault();
}

function gridFields() {
return Object.freeze([
        {
        key: 'emArchFaultTypeName',
        label: 'label.em.archive.emArchFault.grid.emArchFaultTypeName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.archive.emArchFault.grid.emArchBasicDataCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBasicDataName',
        label: 'label.em.archive.emArchFault.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.archive.emArchFault.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.archive.emArchFault.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'faultDetail',
        label: 'label.em.archive.emArchFault.grid.faultDetail',
        sortable: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'faultEffect',
        label: 'label.em.archive.emArchFault.grid.faultEffect',
        sortable: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'faultSymptom',
        label: 'label.em.archive.emArchFault.grid.faultSymptom',
        sortable: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'faultCause',
        label: 'label.em.archive.emArchFault.grid.faultCause',
        sortable: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'faultCauseExplanation',
        label: 'label.em.archive.emArchFault.grid.faultCauseExplanation',
        sortable: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'attachmentList',
        label: 'label.em.archive.emArchFault.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'emArchToolKitName',
        label: 'label.em.archive.emArchFault.grid.emArchToolKitName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'authorName',
        label: 'label.em.archive.emArchFault.grid.authorName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewerId',
        label: 'label.em.archive.emArchFault.grid.reviewerId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewerName',
        label: 'label.em.archive.emArchFault.grid.reviewerName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'approvalStatus',
        label: 'label.em.archive.emArchFault.grid.approvalStatus',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '准备送审' },
                            { value: '2', text: '审批中' },
                            { value: '3', text: '审批通过' }
            ]
        }
        },
        {
        key: 'isGeneral',
        label: 'label.em.archive.emArchFault.grid.isGeneral',
        sortable: true,
        form: {
        type: 'boolean'
        }
        }
]);
}

const filter = {
    emArchFaultTypeIdFilter : "",
    emArchBasicDataCodeFilter : "",
    codeFilter : "",
    nameFilter : "",
    faultDetailFilter : "",
    faultEffectFilter : "",
    faultSymptomFilter : "",
    faultCauseFilter : "",
    faultCauseExplanationFilter : "",
    emArchToolKitIdFilter : "",
    isGeneralFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emArchFaultTypeIdFilter',
        label: 'label.em.archive.emArchFault.filter.emArchFaultTypeId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchFaultType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.archive.emArchFault.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.archive.emArchFault.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.archive.emArchFault.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'faultDetailFilter',
        label: 'label.em.archive.emArchFault.filter.faultDetail',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'faultEffectFilter',
        label: 'label.em.archive.emArchFault.filter.faultEffect',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'faultSymptomFilter',
        label: 'label.em.archive.emArchFault.filter.faultSymptom',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'faultCauseFilter',
        label: 'label.em.archive.emArchFault.filter.faultCause',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'faultCauseExplanationFilter',
        label: 'label.em.archive.emArchFault.filter.faultCauseExplanation',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emArchToolKitIdFilter',
        label: 'label.em.archive.emArchFault.filter.emArchToolKitId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchToolKit'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'isGeneralFilter',
        label: 'label.em.archive.emArchFault.filter.isGeneral',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'emArchFaultTypeId',
        label: 'label.em.archive.emArchFault.entity.emArchFaultTypeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchFaultType'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.archive.emArchFault.entity.emArchBasicDataCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'code',
        label: 'label.em.archive.emArchFault.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.archive.emArchFault.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'faultDetail',
        label: 'label.em.archive.emArchFault.entity.faultDetail',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
            ,required: true
                }
        },
        {
        key: 'faultEffect',
        label: 'label.em.archive.emArchFault.entity.faultEffect',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'faultSymptom',
        label: 'label.em.archive.emArchFault.entity.faultSymptom',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'faultCause',
        label: 'label.em.archive.emArchFault.entity.faultCause',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'faultCauseExplanation',
        label: 'label.em.archive.emArchFault.entity.faultCauseExplanation',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'emArchToolKitId',
        label: 'label.em.archive.emArchFault.entity.emArchToolKitId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchToolKit'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'isGeneral',
        label: 'label.em.archive.emArchFault.entity.isGeneral',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'attachmentList',
        label: 'label.em.archive.emArchFault.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'attachment'
                }
        }
]

export {EmArchFault, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
